/*
 * Copyright (c) 2023-2024 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import { LoadingOutlined } from '@ant-design/icons'
import { CustomOAuthClient } from '@cp/ic-sdk'
import { useLocation } from '@remix-run/react'
import { Spin } from 'antd'
import { useEffect, useRef } from 'react'
import { PathHelpers } from '~/helpers/PathHelpers'
import { BROWSER_IC_BASE_URL_SDK } from '~/hooks/useSdk'

// TODO: refactor to use useEffectOnce.
export function LoginRedirection({ returnPath }: { returnPath: string | undefined }) {
  const { pathname } = useLocation()
  // This is to prevent double redirection in local.
  // When we do `createLoginURL`, we save CSRF challenge in our local storage.
  // It will be reused later when we exchange token. However, if we redirect twice, then the first CSRF token that we stored
  // will be overridden by the second one, causing the code exchange will result in different CSRF token.
  const isRedirecting = useRef(false)

  useEffect(() => {
    if (isRedirecting.current) return

    // To create the login URL, we want to create using the plain IC base URL SDK, because it doesn't contain
    // the `/web/proxy` path; we want to redirect directly to the `/authorize` endpoint
    const targetPath = returnPath === PathHelpers.LOGOUT ? '/' : (returnPath ?? pathname)

    const url = new CustomOAuthClient(BROWSER_IC_BASE_URL_SDK).createLoginURL(targetPath)

    isRedirecting.current = true
    window.location.href = url
  }, [pathname, returnPath])

  return (
    <div className="flex h-screen w-full flex-col items-center justify-center">
      <Spin indicator={<LoadingOutlined />} size="large" className="mb-4" />
      <p>Navigating to login page...</p>
    </div>
  )
}
